/**
 * Company info — central source of truth for Impressum + Datenschutz.
 * Update here if details change.
 */
export const COMPANY = {
  name: "Simonsen Freianlagen Freiraumplanungsgesellschaft mbH",
  shortName: "Simonsen Freianlagen",
  appName: "BaugrundCheck.de",
  subtitle: "Büro und Schaugarten",
  address: {
    street: "Dresdner Straße 28",
    zip: "01723",
    city: "Wilsdruff bei Dresden",
    country: "Deutschland",
  },
  sitz: {
    street: "Friedrichstraße 29",
    zip: "01067",
    city: "Dresden",
  },
  phone: "+49 (0) 35204 785480",
  fax: "+49 (0) 35204 785488",
  email: "info@simonsen.de", // displayed as info(at)simonsen.de to discourage scraping
  emailDisplay: "info(at)simonsen.de",
  privacyEmail: "info@simonsen.de",
  privacyEmailDisplay: "info(at)simonsen.de",
  registerCourt: "Amtsgericht Dresden",
  registerNumber: "HRB 19276",
  taxNumber: "203/118/05836",
  vatId: "DE 199230313",
  managingDirector: "Michael Simonsen",
  responsibleForContent: "Michael Simonsen",
};
